import MyProfile from './pages/MyProfile';
import NonProductionAssessments from './components/NonProductionAssessments';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Suppliers from './pages/Suppliers';
import Products from './pages/Products';
import Materials from './pages/Materials';
import MaterialSKUs from './pages/MaterialSKUs';
import ConversionRules from './pages/ConversionRules';
import InventoryReceipts from './pages/InventoryReceipts';
import MaterialIssues from './pages/MaterialIssues';
import MaterialConversionRequests from './pages/MaterialConversionRequests';
import StockCounts from './pages/StockCounts';
import InventoryAdjustments from './pages/InventoryAdjustments';
import Orders from './pages/Orders';
import Invoices from './pages/Invoices';
import Bills from './pages/Bills';
import Cashbook from './pages/Cashbook';
import Inventory from './pages/Inventory';
import InventoryAuditorWorkspace from './pages/InventoryAuditorWorkspace';
import Users from './pages/Users';
import StaffBiodata from './pages/StaffBiodata';
import AuditLog from './pages/AuditLog';
import CustomProducts from './pages/CustomProducts';
import InvoiceSettings from './pages/InvoiceSettings';
import Expenses from './pages/Expenses';
import Payments from './pages/Payments';
import Banking from './pages/Banking';
import SupplierDashboard from './pages/SupplierDashboard';
import PurchaseOrders from './pages/PurchaseOrders';
import Reports from './pages/Reports';
import Payroll from './pages/Payroll';
import CRM from './pages/CRM';
import SalesManagerDashboard from './pages/SalesManagerDashboard';
import Tasks from './pages/Tasks';
import MyPayslips from './pages/MyPayslips';
import SalesTargets from './pages/SalesTargets';
import TeamReports from './pages/TeamReports';
import AdvancedReports from './pages/AdvancedReports';
import EMD from './pages/EMD';
import PendingRefunds from './pages/PendingRefunds';
import JobCostingReport from './pages/JobCostingReport';
import Leave from './pages/Leave';
import Assets from './pages/Assets';
import ProductionDashboard from './pages/ProductionDashboard';
import FinanceDashboard from './pages/FinanceDashboard';
import Deliveries from './pages/Deliveries';
import OperationsDashboard from './pages/OperationsDashboard';
import HRDashboardPage from './pages/HRDashboardPage';
import BloansStandard from './pages/BloansStandard';
import StewardContributions from './pages/StewardContributions';
import BrandContentDashboard from './pages/BrandContentDashboard';
import BrandContent from './pages/BrandContent';
import BrandCampaigns from './pages/BrandCampaigns';
import BrandAssets from './pages/BrandAssets';
import BrandBlog from './pages/BrandBlog';
import BrandWebsite from './pages/BrandWebsite';
import BrandMarketplace from './pages/BrandMarketplace';
import BrandResources from './pages/BrandResources';
import JobCosting from './pages/JobCosting';
import Loans from './pages/Loans';
import PayrollEnrolments from './pages/PayrollEnrolments';
import ChangePassword from './pages/ChangePassword';
import StockLedger from './pages/StockLedger';
import Prospects from './pages/Prospects';
import DocumentTemplates from './pages/DocumentTemplates';
import DocumentResponse from './pages/DocumentResponse';
import Documents from './pages/Documents';
import AttendanceKiosk from './pages/AttendanceKiosk';
import AIBriefing from './pages/AIBriefing';
import Attendance from './pages/Attendance';
import StaffIDCards from './pages/StaffIDCards';
import BirthdayCalendar from './pages/BirthdayCalendar';
import Departments from './pages/Departments';
import Requisitions from './pages/Requisitions';
import StaffChecklists from './pages/StaffChecklists';
import RolesPermissions from './pages/RolesPermissions';
import Organogram from './pages/Organogram';
import JobDescriptions from './pages/JobDescriptions';
import PurchaseRequests from './pages/PurchaseRequests';
import Offboarding from './pages/Offboarding';
import Onboarding from './pages/Onboarding';
import ProductionCounts from './pages/ProductionCounts';
import ManagerDashboard from './pages/ManagerDashboard';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import JobOrders from './pages/JobOrders';
import FrontDesk from './pages/FrontDesk';
import MyVisitors from './pages/MyVisitors';
import OrderConfirmationPublic from './pages/OrderConfirmationPublic';
import PurchaseOrderResponse from './pages/PurchaseOrderResponse';

import InvoicePaymentPublic from './pages/InvoicePaymentPublic';
const Protected = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
};


function RoleBasedHome() {
  const { user } = useAuth();
  if (!user) return <Dashboard />;
  const productionRoles = ['production_assistant','production_staff','tailor','driver','support_staff'];
  if (user.role === 'inventory_officer') return <Navigate to="/production-dashboard" replace />;
  if (user.role === 'front_desk_officer') return <Navigate to="/front-desk" replace />;
  if (user.role === 'brand_content_officer') return <Navigate to="/bc-dashboard" replace />;
  if (productionRoles.includes(user.role)) return <Navigate to="/tasks" replace />;
  return <Dashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/forgot-password"
            element={<ForgotPassword />}
          />
          <Route
            path="/reset-password/:token"
            element={<ResetPassword />}
          />
      <Route path="/kiosk" element={<AttendanceKiosk />} />
        <Route path="/documents/respond/:token" element={<DocumentResponse />} />
        <Route
          path="/order-confirmation/:token"
          element={<OrderConfirmationPublic />}
        />
        <Route
          path="/purchase-order/respond/:token"
          element={<PurchaseOrderResponse />}
        />
          <Route
            path="/pay/invoice/:token"
            element={<InvoicePaymentPublic />}
          />
          <Route path="/" element={<Protected><AppShell /></Protected>}>
            <Route index element={<RoleBasedHome />} />
            <Route path="customers" element={<Customers />} />
            <Route path="suppliers" element={<Suppliers />} />
            <Route path="products" element={<Products />} />
            <Route path="materials" element={<Materials />} />
            <Route path="material-skus" element={<MaterialSKUs />} />
            <Route path="conversion-rules" element={<ConversionRules />} />
            <Route path="inventory-receipts" element={<InventoryReceipts />} />
            <Route path="material-conversion" element={<MaterialConversionRequests />} />
            <Route path="stock-counts" element={<StockCounts />} />
            <Route path="inventory-adjustments" element={<InventoryAdjustments />} />
            <Route path="orders" element={<Orders />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="bills" element={<Bills />} />
            <Route path="cashbook" element={<Cashbook />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="material-issues" element={<MaterialIssues />} />
            <Route path="inventory-audit" element={<InventoryAuditorWorkspace />} />
            <Route path="users" element={<Users />} />
            <Route path="staff-biodata" element={<StaffBiodata />} />
            <Route path="audit" element={<AuditLog />} />
            <Route path="custom-products" element={<CustomProducts />} />
            <Route path="invoice-settings" element={<InvoiceSettings />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="payments" element={<Payments />} />
            <Route path="banking" element={<Banking />} />
            <Route path="supplier-dashboard" element={<SupplierDashboard />} />
            <Route path="purchase-orders" element={<PurchaseOrders />} />
            <Route path="reports" element={<Reports />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="crm" element={<CRM />} />
            <Route path="sales-manager-dashboard" element={<SalesManagerDashboard />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="my-payslips" element={<MyPayslips />} />
            <Route path="my-profile" element={<MyProfile />} />
            <Route path="sales-targets" element={<SalesTargets />} />
            <Route path="team-reports" element={<TeamReports />} />
            <Route path="advanced-reports" element={<AdvancedReports />} />
            <Route path="emd" element={<EMD />} />
            <Route path="refunds-pending" element={<PendingRefunds />} />
            <Route path="sops" element={<BloansStandard initialView="sop_library" />} />
            <Route path="job-costing-report" element={<JobCostingReport />} />
            <Route path="leave" element={<Leave />} />
            <Route path="assets" element={<Assets />} />
            <Route path="production-dashboard" element={<ProductionDashboard />} />
            <Route path="finance-dashboard" element={<FinanceDashboard />} />
            <Route path="hr-dashboard" element={<HRDashboardPage />} />
            <Route path="deliveries" element={<Deliveries />} />
            <Route path="operations-dashboard" element={<OperationsDashboard />} />
            <Route path="bloans-standard" element={<BloansStandard />} />
            <Route path="steward-contributions" element={<StewardContributions />} />
            <Route path="bc-dashboard" element={<BrandContentDashboard />} />
            <Route path="bc-content" element={<BrandContent />} />
            <Route path="bc-campaigns" element={<BrandCampaigns />} />
            <Route path="bc-assets" element={<BrandAssets />} />
            <Route path="bc-blog" element={<BrandBlog />} />
            <Route path="bc-website" element={<BrandWebsite />} />
            <Route path="bc-marketplace" element={<BrandMarketplace />} />
            <Route path="bc-resources" element={<BrandResources />} />
            <Route path="job-costing" element={<JobCosting />} />
            <Route path="loans" element={<Loans />} />
            <Route path="stock-ledger" element={<StockLedger />} />
            <Route path="prospects" element={<Prospects />} />
            <Route path="payroll-enrolments" element={<PayrollEnrolments />} />
            <Route path="document-templates" element={<DocumentTemplates />} />
              <Route path="documents" element={<Documents />} />
            <Route path="ai-briefing" element={<AIBriefing />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="staff-id-cards" element={<StaffIDCards />} />
            <Route path="birthday-calendar" element={<BirthdayCalendar />} />
            <Route path="departments" element={<Departments />} />
            <Route path="requisitions" element={<Requisitions />} />
            <Route path="staff-checklists" element={<StaffChecklists />} />
            <Route path="roles-permissions" element={<RolesPermissions />} />
            <Route path="organogram" element={<Organogram />} />
            <Route path="job-descriptions" element={<JobDescriptions />} />
            <Route path="purchase-requests" element={<PurchaseRequests />} />
            <Route path="offboarding" element={<Offboarding />} />
            <Route path="onboarding" element={<Onboarding />} />
            <Route path="production-counts" element={<ProductionCounts />} />
      <Route path="non-production-assessments" element={<NonProductionAssessments />} />
            <Route path="manager-dashboard" element={<ManagerDashboard />} />
            <Route path="my-payslips" element={<MyPayslips />} />
            <Route path="sales-targets" element={<SalesTargets />} />
            <Route path="team-reports" element={<TeamReports />} />
            <Route path="advanced-reports" element={<AdvancedReports />} />
            <Route path="emd" element={<EMD />} />
            <Route path="refunds-pending" element={<PendingRefunds />} />
            <Route path="sops" element={<BloansStandard initialView="sop_library" />} />
            <Route path="job-costing-report" element={<JobCostingReport />} />
            <Route path="leave" element={<Leave />} />
            <Route path="assets" element={<Assets />} />
            <Route path="production-dashboard" element={<ProductionDashboard />} />
            <Route path="ai-briefing" element={<AIBriefing />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="staff-id-cards" element={<StaffIDCards />} />
            <Route path="birthday-calendar" element={<BirthdayCalendar />} />
            <Route path="departments" element={<Departments />} />
            <Route path="requisitions" element={<Requisitions />} />
            <Route path="staff-checklists" element={<StaffChecklists />} />
            <Route path="roles-permissions" element={<RolesPermissions />} />
            <Route path="organogram" element={<Organogram />} />
            <Route path="job-descriptions" element={<JobDescriptions />} />
            <Route path="purchase-requests" element={<PurchaseRequests />} />
            <Route path="offboarding" element={<Offboarding />} />
            <Route path="onboarding" element={<Onboarding />} />
            <Route path="production-counts" element={<ProductionCounts />} />
            <Route path="manager-dashboard" element={<ManagerDashboard />} />
            <Route path="job-orders" element={<JobOrders />} />
            <Route path="front-desk" element={<FrontDesk />} />
              <Route path="my-visitors" element={<MyVisitors />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
